import {Modal, InputNumber} from 'antd';
import {useState} from 'react';

export const DestroyModal = ({open, onOk, onCancel, max}) => {
    const [numDestroy, setNumDestroy] = useState(0);

    const onChange = (val) => {
        setNumDestroy(val);
    }

    const onModalOk = () => {
        if (onOk) {
            onOk(numDestroy);
        }
    }

    return <Modal title={`Enter the Number of Plants Destroyed`} open={open} onOk={onModalOk} onCancel={onCancel}>
        <InputNumber min={0} max={max} precision={0} onChange={onChange} value={numDestroy}/>
    </Modal>
}